import { FormConfig } from '@frontend/design-system';
import { textField } from '../../../utils/field-config-helpers';

export type MissedCallsFieldTypes = typeof missedCallsFields;

export const missedCallsFields = {
  introMessage: textField({
    required: true,
  }),
} satisfies FormConfig;
